import { render, staticRenderFns } from "./InvoiceSupplierHorse.vue?vue&type=template&id=9863139c&"
import script from "./InvoiceSupplierHorse.vue?vue&type=script&lang=js&"
export * from "./InvoiceSupplierHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports